import React from "react";
import { PageSeo } from "../components/PageSeo";
import { MenuSection } from "../components/MenuSection";

export function RestoranPage() {
  return (
    <>
      <PageSeo
        title="Restoran Kragujevac | Meni i cenovnik | RESTORAN KRČMA"
        description="Pogledajte meni i cenovnik restorana KRČMA u Kragujevcu: nacionalna kuhinja, roštilj i specijaliteti."
        keywords="restoran Kragujevac, meni restoran Kragujevac, nacionalna kuhinja Kragujevac"
        path="/restoran"
      />
      <MenuSection />
    </>
  );
}

